import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/account',
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  const url = '/account/' + id
  return request({
    url,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/account'
  if (data.id) {
    method = 'put'
    url = '/account/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (id) {
  return request({
    url: '/account/' + id,
    method: 'delete',
  })
}

export function getRoles () {
  return ['Administrator', 'Employee', 'Medical Monitor', 'CRO Pharmacovigilance', 'Guest', 'EMN Client', 'Provider']
}

export function getStatuses () {
  return ['Active', 'Disabled']
}
